import { render, staticRenderFns } from "./SerieBanner.vue?vue&type=template&id=16f5aec6&scoped=true&"
import script from "./SerieBanner.vue?vue&type=script&lang=js&"
export * from "./SerieBanner.vue?vue&type=script&lang=js&"
import style0 from "./SerieBanner.vue?vue&type=style&index=0&id=16f5aec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f5aec6",
  null
  
)

export default component.exports